import C from 'actionTypes'

const defaultState = {
  isInitialLoad: true,
  loadingPortfolio: false,
  loadingPortfolioAccounts: false,
  loadingPortfolioClassAllocations: false,
  loadingPortfolioHoldings: false,
  loadingDocuments: false,
}

const  isInitialLoad =  (state = { isInitialLoad: true }, action) => {
  const { value } = action

  switch (action.type) {
    case C.SET_IS_INITIAL_LOAD:
      return {
        ...state,
        isInitialLoad: value,
      }
    default:
      return state
  }
}

const loadingPortfolio = (state = defaultState.loadingPortfolio, action) => {
  const { value } = action

  switch (action.type) {
    case C.SET_PORTFOLIO_IS_LOADING:
      return {
        ...state,
        loadingPortfolio: value,
      }
    default:
      return state
  }
}

const loadingPortfolioAccounts = (state = defaultState.loadingPortfolioAccounts, action) => {
  const { value } = action

  switch (action.type) {
    case C.SET_PORTFOLIO_ACCOUNTS_ARE_LOADING:
      return {
        ...state,
        loadingPortfolioAccounts: value,
      }
    default:
      return state
  }
}

const loadingPortfolioClassAllocations = (...params) => {
  const [state = defaultState.loadingPortfolioClassAllocations, action] = params
  const { value } = action

  switch (action.type) {
    case C.SET_PORTFOLIO_CLASS_ALLOCATIONS_ARE_LOADING:
      return {
        ...state,
        loadingPortfolioClassAllocations: value,
      }
    default:
      return state
  }
}

const loadingPortfolioHoldings = (state = defaultState.loadingPortfolioHoldings, action) => {
  const { value } = action

  switch (action.type) {
    case C.SET_PORTFOLIO_HOLDINGS_ARE_LOADING:
      return {
        ...state,
        loadingPortfolioHoldings: value,
      }
    default:
      return state
  }
}

const loadingDocuments = (state = defaultState.loadingDocuments, action) => {
  const { value } = action

  switch (action.type) {
    case C.SET_DOCUMENTS_ARE_LOADING:
      return {
        ...state,
        loadingDocuments: value,
      }
    default:
      return state
  }
}

export default {
  isInitialLoad,
  loadingPortfolio,
  loadingPortfolioAccounts,
  loadingPortfolioClassAllocations,
  loadingPortfolioHoldings,
  loadingDocuments,
}



// WEBPACK FOOTER //
// ./src/reducers/client/loading.js